import { useState } from 'react';

import { GA4EventName, GA4FeatureCategory, trackAnalyticsEvent } from '@jsmdg/tracking';

interface AccordionTracking {
    isExpanded: boolean;
    toggleTracking: (expandText: string, collapseText: string) => void;
}

const collapseTracking = (collapseText: string): void => {
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'TextClickDescription',
        label: collapseText,
        eventData: {
            eventName: GA4EventName.ClickButton,
            feature_category: GA4FeatureCategory.ProductDetailInformation,
            click_element: 'Close details description',
            click_text: collapseText,
        },
    });
};

const expandTracking = (expandText: string): void => {
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'TextClickDescription',
        label: expandText,
        eventData: {
            eventName: GA4EventName.ClickButton,
            feature_category: GA4FeatureCategory.ProductDetailInformation,
            click_element: 'Open details description',
            click_text: expandText,
        },
    });
};

function useAccordionTracking(): AccordionTracking {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleTracking = (expandText: string, collapseText: string): void => {
        if (isExpanded) {
            collapseTracking(collapseText);
        } else {
            expandTracking(expandText);
        }

        setIsExpanded(!isExpanded);
    };

    return {
        isExpanded,
        toggleTracking,
    };
}

export { useAccordionTracking };
